module.exports = __webpack_public_path__ + "img/01ebde9.png";